import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./Routes/App";
import { AdminDashboard } from "./Routes/AdminDashboard";
import { CustomerSignUp } from "./Routes/CustomerSignUp";



export const BrowserRoutes = () => {






    return <BrowserRouter>
        <Routes>
            <Route path="/" element={<App user_origin={"normal"}/>} />
            <Route path="/synthetic_oil_special_deal" element={<App user_origin={"facebook_synthetic_oil_deal"}/>} />
            <Route path="/general_services_special_deal" element={<App user_origin={"facebook_general_services"} />} /> 
            <Route path="/admin-dashboard-nova-auto-9106-euclid" element={<AdminDashboard />} />
            <Route path="/customer_sign_up" element={<CustomerSignUp />} />
            <Route path="/*" element={<App user_origin={"normal"} />} /> 
        </Routes>
    </BrowserRouter>
}